module.exports = __webpack_public_path__ + "static/img/areaA_2.43b73b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA_2.png
// module id = 1065
// module chunks = 1